import styled from 'styled-components';

export const AdditionalOptionsWrapper = styled.div`
  border: solid 1px #e7e7e7;
  border-radius: 12px;
  padding: 30px;
  font-size: 14px;
  margin-top: 16px;

  @media (max-width: 600px) {
    border: none;
    padding: 16px;
  }

  h4 {
    margin-top: 0;
  }
`;

export const AdditionalOption = styled.a`
  text-decoration: none;
  cursor: pointer;

  color: var(--secondary-brand-main);
  background: #f9f9f9;
  margin: 0 6px 6px 0;
  padding: 8px;
  border-radius: 8px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`;
